import React from "react";
import { RolesField, RoleAccesibilityField } from '../../../Utilities/Enums/ParametersEnum';
import { ActiveStatusEnum } from '../../../Utilities/Enums/StatusEnums';
import { RoleTypeEnum } from '../../../Utilities/Enums/RolesEnums';

// export class RolesList {
//     [RolesListField.PUBLIC_ID]?: string | number = "";
//     [RolesListField.NAME]?: string = "";
//     [RolesListField.DESCRIPTION]: string = "";
//     [RolesField.STATUS]: ActiveStatusEnum = 1;
//     [RolesListField.CREATED_DATE]?: string | Date | null = null;
//     [RolesListField.UPDATED_DATE]?: string | Date | null = null;

//     constructor(obj?: Partial<RolesList>) {
//         Object.assign(this, obj);
//     }
// }

export class Role {
    [RolesField.PUBLIC_ID]?: string | number = "";
    [RolesField.NAME]?: string = "";
    [RolesField.TYPE]?: RoleTypeEnum = RoleTypeEnum.DEFAULT;
    [RolesField.DESCRIPTION]: string = "";
    [RolesField.STATUS]: ActiveStatusEnum = 1;
    [RolesField.CREATED_DATE]?: string | Date | null = null;
    [RolesField.UPDATED_DATE]?: string | Date | null = null;

    constructor(obj?: Partial<Role>) {
        Object.assign(this, obj);
    }
}

export class RoleAccesibility {
    [RoleAccesibilityField.ACCESSIBILITY_ID]?: number = 0;
    [RoleAccesibilityField.IS_PERMITTED]?: boolean = false;

    constructor(obj?: Partial<Role>) {
        Object.assign(this, obj);
    }
}

export class AddEditRoleModalInterface {
    openAddEditModal?: boolean;
    setopenAddEditModal?: React.Dispatch<React.SetStateAction<boolean>>;
    selectedRole?: Role;
    setselectedRole?: React.Dispatch<React.SetStateAction<Role>>;

    constructor(obj?: Partial<AddEditRoleModalInterface>) {
        Object.assign(this, obj);
    }
}